import React, { useRef } from 'react';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Page,
  Toolbar,
  ExcelExport,
  PdfExport,
  ColumnChooser,
} from '@syncfusion/ej2-react-grids';
import has from 'lodash/has';
import toString from 'lodash/toString';
import { PdfTrueTypeFont } from '@syncfusion/ej2-pdf-export';
import { calibriFont } from 'constant/PdfFont';

const LateDriversDataGrid = ({ data }) => {
  const toolbarOptions = ['ExcelExport', 'PdfExport', 'CsvExport', 'ColumnChooser', 'Search'];
  const ref = useRef();

  const toolbarClick = (args) => {
    const pdfExportProperties = {
      theme: {
        caption: { font: new PdfTrueTypeFont(calibriFont, 10) },
        header: { font: new PdfTrueTypeFont(calibriFont, 12) },
        record: { font: new PdfTrueTypeFont(calibriFont, 9) },
      },
    };
    switch (args.item.text) {
      case 'PDF Export':
        ref.current.pdfExport(pdfExportProperties);
        break;
      case 'Excel Export':
        ref.current.excelExport();
        break;
      case 'CSV Export':
        ref.current.csvExport();
        break;
      default:
        break;
    }
  };

  // custom columns
  const idTemplate = (rowData) => {
    return (
      <div className="d-flex flex-column btns-column">
        <p>{parseInt(rowData.index, 10) + 1}</p>
      </div>
    );
  };

  const driverNameTemplate = (rowData) => {
    return <p className="total-txt">{rowData.driverName}</p>;
  };

  const countDeliverdTemplate = (rowData) => {
    return <p className="total-txt">{rowData.countDeliverd}</p>;
  };

  const countTemplate = (rowData) => {
    return <p className="total-txt">{rowData.count}</p>;
  };

  const percentageTemplate = (rowData) => {
    return <p className="total-txt">{Math.round((rowData.count * 100) / rowData.countDeliverd)}</p>;
  };

  const excelQueryCellInfo = (args) => {
    if (has(args.column, 'customExcelTemplate')) {
      args.value = toString(args.column.customExcelTemplate(args.data));
    }
  };

  return (
    <div className="control-pane">
      <div className="card-header p-18">
        <h5 className="sz-14">Late Drivers</h5>
      </div>
      <div className="control-section">
        <GridComponent
          dataSource={data}
          allowPaging={true}
          toolbar={toolbarOptions}
          allowExcelExport={true}
          allowPdfExport={true}
          excelQueryCellInfo={excelQueryCellInfo}
          pdfQueryCellInfo={excelQueryCellInfo}
          ref={ref}
          toolbarClick={toolbarClick}
          showColumnChooser={true}
          rowHeight={60}
          allowTextWrap={true}
          pageSettings={{ pageSizes: true, pageSize: 20 }}
        >
          <ColumnsDirective>
            <ColumnDirective headerText="#" width={100} template={idTemplate} />
            <ColumnDirective
              headerText="DriverName"
              field="driverName"
              width={100}
              template={driverNameTemplate}
              customExcelTemplate={(rowData) => rowData.driverName}
            />
            <ColumnDirective
              headerText="Delivered"
              field="countDeliverd"
              width={100}
              template={countDeliverdTemplate}
              customExcelTemplate={(rowData) => rowData.countDeliverd}
            />
            <ColumnDirective
              headerText="Late"
              field="count"
              width={100}
              template={countTemplate}
              customExcelTemplate={(rowData) => rowData.count}
            />
            <ColumnDirective
              headerText="Percentage"
              width={100}
              template={percentageTemplate}
              customExcelTemplate={(rowData) =>
                Math.round((rowData.count * 100) / rowData.countDeliverd)
              }
            />
          </ColumnsDirective>
          <Inject services={[Page, Toolbar, ExcelExport, PdfExport, ColumnChooser]} />
        </GridComponent>
      </div>
    </div>
  );
};

export default React.memo(LateDriversDataGrid);
